import './DeathNotificationTermsAndConditions.scss';
import React from 'react';
import {
  Content,
  contentConverter
} from 'utils/Content';

const DeathNotificationTermsAndConditions = () => {
  const termsAndConditions = contentConverter.makeHtml(Content.TermsAndConditions)
  return <p className="important-disclosure-content"
            dangerouslySetInnerHTML={{ __html:termsAndConditions }} />
};

export default DeathNotificationTermsAndConditions;
